import { Pipe, PipeTransform } from '@angular/core';
import { TabloCustomGraphicConfig } from '@ui/tablo-generator/types';
import { SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
    name: 'customGraphicStyles',
    standalone: false
})
export class CustomGraphicStylesPipe implements PipeTransform {
  transform(
    value: { config: TabloCustomGraphicConfig },
    imageUrl: SafeResourceUrl,
  ): Record<string, any> {
    const styles: Record<string, string> = {};
    if (value.config.hidden) {
      styles.opacity = '0';
    }

    if (
      value.config.config?.hasColorOverlay &&
      // @ts-ignore
      imageUrl?.changingThisBreaksApplicationSecurity
    ) {
      styles.backgroundColor = value.config.config.colorOverlay;
      // @ts-ignore
      styles.mask = `url(${imageUrl.changingThisBreaksApplicationSecurity}) center / contain no-repeat`;
    }
    console.log({
      styles,
    });
    return styles;
  }
}
